import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import Development from '~/Components/Development/Development.jsx';

Sentry.init( {
	dsn: "https://d07a86b570734823b6cf967e22b54584@sentry.pit.edu/3",
	environment: '//%{SENTRY_ENV}',
	integrations: [
		new BrowserTracing(),
		new Sentry.Replay(),
	],
	tracesSampleRate: 1.0,
	// This sets the sample rate to be 10%. You may want this to be 100% while
	// in development and sample at a lower rate in production
	replaysSessionSampleRate: 0.1,
	// If the entire session is not sampled, use the below sample rate to sample
	// sessions when an error occurs.
	replaysOnErrorSampleRate: 1.0,
} );

export default class PIT {
	
	static Development = new Development();
	
	static pluginURL = "/wp-content/plugins/pitv2";
	static environment = '//%{SENTRY_ENV}';

	/**
	 * 
	 * Since webpack 4 the default is needed to let webpack know that this is not a
	 * ecmascript import to add to its custom namespace, it is something we need to
	 * lazy load.
	 */
	static getComponent = async ( name ) => {

		let component;
		
		if ( name === "Admin" ) {

			let { default: _ } = await import( "./Components/Admin/Admin.jsx" );
			component = _;
		} else if ( name === "Alert" ) {

			let { default: _ } = await import( "./Common/JSX/Components/Alert.jsx" );
			component = _;
		} else if ( name === "Application" ) {

			let { default: _ } = await import( "./Components/Application/ErrorBoundary.jsx" );
			component = _;
		} else if ( name === "Captcha" ) {

			let { default: _ } = await import( "./Components/Captcha/Captcha.jsx" );
			component = _;
		} else if ( name === "Common" ) {

			let { default: _ } = await import( "./Common/JSX/Components/Common.jsx" );
			component = _;
		} else if ( name === "Events" ) {

			let { default: _ } = await import( "./Components/Events/Events.jsx" );
			component = _;
		} else if ( name === "Initialize" ) {

			let { default: _ } = await import( "./Components/Initialize/Initialize.jsx" );
			component = _;
		} else if ( name === "Programs" ) {

			let { default: _ } = await import( "./Components/Programs/Programs.jsx" );
			component = _;
		} else if ( name === "React" ) {

			let { default: _ } = await import( "react" );
			component = _;
		} else if ( name === "ReactDOM" ) {

			let { default: _ } = await import( "react-dom" );
			component = _;
		} else if ( name === "Reports" ) {

			let { default: _ } = await import( "./Components/Reports/Reports.jsx" );
			component = _;
		} else if ( name === "Sentry" ) {

			let _ = await import( "@sentry/react" );
			component = _;
		} else if ( name === "Sentry-Integrations" ) {

			let { Integrations: _ } = await import( "@sentry/tracing" );
			component = _;
		} else if ( name === "Users" ) {

			let { default: _ } = await import( "./Components/Users/Users.jsx" );
			component = _;
		}
		return component;
	}

	static initialize = async ( element, props, callback ) => {

		try {

			let Initialize = await this.getComponent( "Initialize" );
			PIT.renderComponent(
				Initialize,
				element,
				{
					...props,
					callback: callback
				}
			);
		} catch( e ) {
			
			console.log( e );
			Sentry.captureException( e );

			try {

				let Alert = await this.getComponent( "Alert" );
				PIT.renderComponent(
					Alert,
					element,
					{
						...props,
						callback: callback,
						message: "An unexpected error occured when attempting to load the root component.",
					}
				);
			} catch( f ) {

				console.log( "Unable to show error message gui" );
				console.log( f );
			}
		}
	}

	static renderComponent = async ( component, element, props = {} ) => {

		let React = await this.getComponent( "React" );
		let ReactDOM = await this.getComponent( "ReactDOM" );
		
		if( typeof element === "string" ) {

			if( element.indexOf( "," ) > -1 ) {

				let elements = element.split( "," );
				let totalElements = elements.length;
	
				for( let i = 0; i < totalElements; i++ ) {
	
					ReactDOM.render(
						React.createElement( component, props ),
						document.querySelector( elements[i] )
					);
				}
			} else {
	
				ReactDOM.render(
					React.createElement( component, props ),
					document.querySelector( element )
				);
			}
		} else {

			ReactDOM.render(
				React.createElement( component, props ),
				element
			);
		}
	}
}